<template>
    <div style="z-index: 99;">
        <div class="mobild-video-handle" v-if="!isShare">
            <span>
                <reo-checkbox v-model="myOpenSelecte" :label="$t('select')" :label-on-select="$t('cancel')" onlyLabel></reo-checkbox>
                <reo-checkbox v-model="mySelectedAll" :label="$t('all')" type="fill" style="margin-left: 0.5rem;" @click="selectAll"></reo-checkbox>
            </span>
            <!-- <reo-button :icon=" lang === 'en' ? 'icon-icon_download' : '' " @click="downloadVideo" :disabled="maxLength !== 1" style="margin:0;">
                {{$t('download')}}
            </reo-button> -->
            <reo-button icon="icon-bin-line" type="gray" @click="deleting = true" :disabled="maxLength === 0" style="border-left: 0; margin:0;padding: 0 0.6rem;">
                {{$t('delete')}}
            </reo-button>
        </div>
        <div class="cloud-handle">
            <div class="cloud-handle-inner">
                <div>
                    <reo-checkbox v-model="myShowExpired" :text="$t('cloud.showExpired')" style="margin-right: 0.8rem;" @click="myShowExpiredHandle" v-if="showExpiredLable"></reo-checkbox>
                    <reo-checkbox v-model="myOpenSelecte" v-if="videoList.length !== 0 && !isShare" :label="$t('cloud.select')" :label-on-select="$t('cloud.selectedLabel')" onlyLabel style="margin-right: 0.8rem;"></reo-checkbox>
                    <reo-checkbox v-model="mySelectedAll" v-if="videoList.length !== 0 && !isShare" :label="$t('selectAll')" type="fill" @click="selectAll" v-show="myOpenSelecte"></reo-checkbox>
                </div>
                <button class="ui-button empty-button short-button" v-if="videoList.length !== 0 && !isShare" @click="deleting = true" :disabled="maxLength === 0" v-show="myOpenSelecte"><span class="ui-logo icon-bin-line"></span>{{$t('delete')}}</button>
            </div>
        </div>
        <confirm-dialog @confirmAction="deleteVideo"  v-if="deleting"></confirm-dialog>
    </div>
</template>

<script>
import ReoCheckbox from '@/basic/Checkbox';
import ReoButton from '@/basic/Button';
import { deleteVideo, downloadVideo } from '@/api/cloud';
import confirmDialog from '@/basic/confirmDialog';
export default {

    props: {

        // 是否是别人分享的设备
        isShare: Boolean,
        openSelecte: Boolean,
        selectedAll: Boolean,
        videoList: Array,
        showExpired: Boolean,
        showExpiredLable: Boolean

    },

    components: {

        ReoCheckbox,
        ReoButton,
        confirmDialog

    },
    data () {

        return {

            mySelectedAll: this.selectedAll,
            myOpenSelecte: this.openSelecte,
            deleting: false,
            myShowExpired: this.showExpired

        };

    },
    mounted () {

        if ( document.body.clientWidth < 1200 ) {

            $( 'footer.pc-body' ).addClass( 'has-handle' );

        }

    },
    destroyed () {

        $( 'footer.pc-body' ).removeClass( 'has-handle' );

    },
    methods: {

        deleteVideo ( goDelete ) {

            if ( goDelete ) {

                let videoIDs = [];
                let videoList = this.videoList;
                for ( let video of videoList ) {

                    if ( video.checked ) {

                        videoIDs.push( video.id );

                    }

                }
                deleteVideo( videoIDs ).then( res => {

                    this.$emit( 'delete', videoIDs );
                    this.$store.dispatch( 'topInfoToggle', {

                        type: 'success',
                        msgIndex: 'suc.delete_video'

                    });

                }).catch( err => {

                    this.$store.dispatch( 'topInfoToggle', {

                        type: 'error',
                        msgIndex: 'errors.delete_video'

                    });
                    console.error( err );

                });

            }
            this.deleting = false;

        },

        downloadVideo () {

            let videoID;
            let videoList = this.videoList;
            for ( let video of videoList ) {

                if ( video.checked ) {

                    videoID = video.id;
                    break;

                }

            }
            downloadVideo( videoID ).then( suc => {
            }).catch( err => {

                this.$store.dispatch( 'topInfoToggle', {

                    type: 'error',
                    msgIndex: 'errors.download_video'

                });
                console.error( err );

            });

        },

        selectAll ( checked ) {

            this.$emit( 'selectedAllHandle', checked );

        },
        myShowExpiredHandle ( checked ) {

            this.$emit( 'showExpiredHanle', checked );

        }

    },

    watch: {

        myOpenSelecte ( myOpenSelecte ) {

            this.$emit( 'openSelecteHandle', myOpenSelecte );

        },
        selectedAll ( selectedAll ) {

            this.mySelectedAll = selectedAll;

        },
        openSelecte ( openSelecte ) {

            this.myOpenSelecte = openSelecte;

        },
        showExpired ( showExpired ) {

            this.myShowExpired = showExpired;

        }

    },
    computed: {

        maxLength () {

            let maxLength = 0;
            let videoList = this.videoList;
            for ( let video of videoList ) {

                if ( video.checked ) {

                    maxLength += 1;

                }
                if ( maxLength === 2 ) {

                    return maxLength;

                }

            }
            return maxLength;

        },
        lang () {

            return this.$store.state.lang.lang;

        }

    }

};
</script>

<style>
    .mobild-video-handle{
        display: none;
    }
    .cloud-handle-inner{
        text-align: left;
        max-width: 1200px;
        margin: auto;
        padding-top: 0.4rem;
        display: flex;
        justify-content: space-between;
        align-items: center;
        height: 0.88rem;
        box-sizing: border-box;
    }
    .cloud-handle-inner .checkbox-wrap-container .text{
        font-weight: 500;
    }
    @media screen and (max-width:1199px) {
        .cloud-handle{
            display: none;
        }
        .mobild-video-handle{
            display: flex;
            align-items: center;
            position: fixed;
            bottom: 0;
            width: 100%;
            background: #fff;
            z-index: 2;
            border-top: 1px solid #ccc;
        }
        .mobild-video-handle>span{
            display: inline-block;
            flex-grow: 1;
            text-align: left;
            padding-left: 15px;
        }
        .mobild-video-handle .checkbox-label{
            font-size: 0.3rem;
        }
    }
</style>



// WEBPACK FOOTER //
// src/view/cloud/VideoHandle.vue